import React from 'react';
import {Icons} from 'components';
import {useNamedSelector} from 'helpers';

export function SyncIcon(props) {
  return (
    <Icons.Spinner {...props} Sub={useNamedSelector('session.offline') && Icons.Close} />
  );
}
